import { jsx } from 'react/jsx-runtime';

function TabList({
  children
}) {
  return /*#__PURE__*/jsx("ul", {
    className: "tabs__tab-list",
    role: "tablist",
    children: children
  });
}

export { TabList as default };
//# sourceMappingURL=TabList.mjs.map
